'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontColorPropTypes = exports.fontColors = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontColors = {
  danger: function danger(_ref) {
    var theme = _ref.theme;
    return 'color: ' + theme.colors.status.danger + ';';
  },
  default: function _default(_ref2) {
    var theme = _ref2.theme;
    return 'color: ' + theme.colors.status.default + ';';
  },
  info: function info(_ref3) {
    var theme = _ref3.theme;
    return 'color: ' + theme.colors.status.info + ';';
  },
  success: function success(_ref4) {
    var theme = _ref4.theme;
    return 'color: ' + theme.colors.status.success + ';';
  },
  text: function text(_ref5) {
    var theme = _ref5.theme;
    return 'color: ' + theme.colors.base.text + ';';
  },
  textLight: function textLight(_ref6) {
    var theme = _ref6.theme;
    return 'color: ' + theme.colors.base.textLight + ';';
  },
  warning: function warning(_ref7) {
    var theme = _ref7.theme;
    return 'color: ' + theme.colors.status.warning + ';';
  }
};

var fontColorPropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      default: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.fontColors = fontColors;
exports.fontColorPropTypes = fontColorPropTypes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/modifiers/fontColors.js
// module id = 1519
// module chunks = 2